import React, {useEffect} from 'react'
import { useIntl } from 'react-intl'
import { useState } from 'react'
import { Grid, IconButton, InputAdornment, OutlinedInput } from '@material-ui/core'
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { Visibility, VisibilityOff } from '@material-ui/icons'
import './CreatePasswordFromGuide.scss'

export const CreatePasswordFromGuide = ({ handlePasswordChange, initPassword }: { handlePasswordChange: (string) => void, initPassword: string }) => {
    const intl = useIntl()
    const [password, setPassword] = useState(initPassword)
    const [repeatPassword, setRepeatPassword] = useState(initPassword)
    const [passwordValidationUppercase, setPasswordValidationUppercase] = useState(false)
    const [passwordValidationLowercase, setPasswordValidationLowercase] = useState(false)
    const [passwordValidationNumbers, setPasswordValidationNumbers] = useState(false)
    const [passwordValidationLength, setPasswordValidationLength] = useState(false)
    const [passwordRepeatError, setPasswordRepeatError] = useState(false)
    const passwordRegexUppercase = /^(?=.*[A-ZÅÄÖ]).+$/
    const passwordRegexLowercase = /^(?=.*[a-zåäö]).+$/
    const passwordRegexNumbers = /^(?=.*[0-9]).+$/
    const [showPassword, setShowPassword] = useState(false)
    const [showRepeatPassword, setShowRepeatPassword] = useState(false)

    const displayError = passwordRepeatError && repeatPassword.length > 0

		useEffect(() => {
			validatePassword(password)
		}, []);

    const validatePassword = (newPassword: string) => {
        setPasswordValidationLength(newPassword.length >= 8 && newPassword.length <= 64)
        setPasswordValidationUppercase(passwordRegexUppercase.test(newPassword))
        setPasswordValidationLowercase(passwordRegexLowercase.test(newPassword))
        setPasswordValidationNumbers(passwordRegexNumbers.test(newPassword))
    }

    const onChangePassword = (value: string) => {
        setPassword(value)
        validatePassword(value)
				setPasswordRepeatError(value !== repeatPassword && repeatPassword.length > 0)

        if (passwordValidationLength && passwordValidationLowercase && passwordValidationUppercase && passwordValidationNumbers && repeatPassword === value) {
            handlePasswordChange(value)
        } else {
            handlePasswordChange('')
        }
    }

    const onChangeRepeatPassword = (value: string) => {
        setRepeatPassword(value)
        setPasswordRepeatError(value !== password && password.length > 0)

        if (passwordValidationLength && passwordValidationLowercase && passwordValidationUppercase && passwordValidationNumbers && value === password) {
            handlePasswordChange(value)
        } else {
            handlePasswordChange('')
        }
    }

    return (
        <Grid container alignItems='center' direction="column" spacing={3} className='create-password-from-grid-container'>
            <Grid item className="input-password-wrapper">
                <OutlinedInput
                    className="input-password"
                    id="standard-adornment-password"
                    type={showPassword ? 'text' : 'password'}
                    value={password}
                    onChange={e => onChangePassword(e.target.value)}
                    fullWidth={true}
                    endAdornment={
                        <InputAdornment position="end">
                            <IconButton
                                aria-label="toggle password visibility"
                                onClick={() => setShowPassword(!showPassword)}
                                onMouseDown={e => e.preventDefault()}
                            >
                                {showPassword ? <Visibility /> : <VisibilityOff />}
                            </IconButton>
                        </InputAdornment>
                    }
                />
            </Grid>

            <Grid item className='input-password-wrapper'>
                <OutlinedInput
                    className="input-password"
                    id="standard-adornment-password"
                    type={showRepeatPassword ? 'text' : 'password'}
                    value={repeatPassword}
                    onChange={e => onChangeRepeatPassword(e.target.value)}
                    fullWidth={true}
                    endAdornment={
                        <InputAdornment position="end">
                            <IconButton
                                aria-label="toggle password visibility"
                                onClick={() => setShowRepeatPassword(!showRepeatPassword)}
                                onMouseDown={e => e.preventDefault()}
                            >
                                {showRepeatPassword ? <Visibility /> : <VisibilityOff />}
                            </IconButton>
                        </InputAdornment>
                    }
                />

            </Grid>
            <Grid item className='password-validation-grid-container'>
                <div className='password-validation-container'>

                    <div className="password-validations-grid" >
                        {passwordValidationLength ? (<div className="password-validations"><CheckCircleIcon fontSize='small' className="check-icon" /><h4 className="validation-text">{intl.formatMessage({ id: 'password.check.length' })}</h4></div>) : (<div className="password-validations"><CheckCircleIcon fontSize='small' color='disabled' /><h4 className="validation-text-disabled">{intl.formatMessage({ id: 'password.check.length' })}</h4></div>)}
                        {passwordValidationUppercase ? (<div className="password-validations"><CheckCircleIcon fontSize='small' className="check-icon" /><h4 className="validation-text">{intl.formatMessage({ id: 'password.check.uppercase' })}</h4></div>) : (<div className="password-validations"><CheckCircleIcon fontSize='small' color='disabled' /><h4 className="validation-text-disabled">{intl.formatMessage({ id: 'password.check.uppercase' })}</h4></div>)}
                        {passwordValidationLowercase ? (<div className="password-validations"><CheckCircleIcon fontSize='small' className="check-icon" /><h4 className="validation-text">{intl.formatMessage({ id: 'password.check.lowercase' })}</h4></div>) : (<div className="password-validations"><CheckCircleIcon fontSize='small' color='disabled' /><h4 className="validation-text-disabled">{intl.formatMessage({ id: 'password.check.lowercase' })}</h4></div>)}
                        {passwordValidationNumbers ? (<div className="password-validations"><CheckCircleIcon fontSize='small' className="check-icon" /><h4 className="validation-text">{intl.formatMessage({ id: 'password.check.numbers' })}</h4></div>) : (<div className="password-validations"><CheckCircleIcon fontSize='small' color='disabled' /><h4 className="validation-text-disabled">{intl.formatMessage({ id: 'password.check.numbers' })}</h4></div>)}
                    </div>

                    <p className={displayError ? "password-repeat-error-text" : "password-repeat-error-text-hidden"}>{intl.formatMessage({ id: 'errormessage.password-mismatch' })}</p>
                </div>
            </Grid>
        </Grid>
    )
}

export default CreatePasswordFromGuide
